'use strict';

import Glide, { Controls, Swipe, Breakpoints, Images, Autoplay, Keyboard } from '@glidejs/glide/dist/glide.modular.esm'

window.glidejs = {Glide, Controls, Swipe, Breakpoints, Images, Autoplay, Keyboard};
window.jQuery = require('jquery');
window.$ = require('jquery');
var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./components/stickyHeader'));
    processInclude(require('./components/legalPrivacyBanner'));
    processInclude(require('./components/loyaltyPointsToggle'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/toolTip'));
    processInclude(require('./components/glideSlider'));
    processInclude(require('./components/ios'));
    processInclude(require('./components/smoothScrollToFragment'));
    processInclude(require('./modal/sessionExpiry'));
    processInclude(require('./components/partnerize'));
    processInclude(require('./components/mbbChat'));
});

require('./thirdParty/bootstrap');
require('./components/spinner');

/**
 * Resolves an issue in Page Designer stemming from CORS between BM URL and SSL Domain (eg. dev.shop.marriott.com)
 * 
 */
(function () {
    // If we're in a Page Designer edit iframe
    if (window?.top !== window?.self && window?.location?.href?.indexOf('mode=EDIT') >= 1) {
        setTimeout(() => {
            // attempt to refresh this frame a bit later
            window.dispatchEvent(new Event('resize'));
        }, 220)
    }
})();